import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "search"
};
const _hoisted_4 = {
  class: "searchItem"
};
const _hoisted_5 = {
  class: "searchItem"
};
const _hoisted_6 = {
  class: "searchItem"
};
const _hoisted_7 = {
  class: "searchItem"
};
const _hoisted_8 = {
  class: "metadata"
};
const _hoisted_9 = {
  class: "metaTitle"
};
const _hoisted_10 = {
  key: 0,
  class: "metaName"
};
const _hoisted_11 = {
  class: "table",
  style: {
    "margin-bottom": "100px",
    "margin-top": "20px"
  }
};
import { reactive, ref } from 'vue';
// import { useRouter } from 'vue-router';
import FooterView from '@/components/footerView.vue';
import { getDataByStratigraphy } from '@/api/index';
import { Cyclostratigraphy, Chemostratigpraphy, lithology, Chronostratigraphy } from '@/utils/tableArr';
import { exportExcel } from '@/utils/exportExcel';
import axios from 'axios';
import { ElMessage } from "element-plus";
export default {
  __name: 'HomeView',
  setup(__props) {
    const activeIndex = ref('1');
    // const router = useRouter();
    // const handleSelect = (key, keyPath) => {
    //   console.log('useRouter函数:', useRouter);
    //
    //   console.log('router实例:', router);
    //   if (key === 'about') {
    //     console.log('About item is clicked, trying to push route');
    //     router.push('/about');
    //   }
    //   console.log(key, keyPath)
    // }
    const stratigrapthyValue = ref('');
    let tableArr = reactive({
      list: []
    });
    const metadataArr = [{
      title: 'Section Or Borehole',
      name: 'section_Or_Borehole'
    }, {
      title: 'Latitude',
      name: 'latitude'
    }, {
      title: 'Longitude',
      name: 'longitude'
    }, {
      title: 'Paleolatitude',
      name: 'paleolatitude'
    }, {
      title: 'Paleolongitude',
      name: 'paleolongitude'
    }, {
      title: 'Formation',
      name: 'formation'
    }, {
      title: 'Depth range(m)',
      name: 'depth_range'
    }, {
      title: 'Lithology',
      name: 'lithology'
    }, {
      title: 'Time',
      name: 'time'
    }, {
      title: 'Related to',
      name: 'reference'
    }];
    const sectionOrBoreholeValue = ref('');
    const stageValue = ref('');
    const countryValue = ref('');
    const stratigraphyOptions = ['Chemostratigraphy', 'Chronostratigraphy', 'Cyclostratigraphy', 'Lithology'];
    const sectionOrBoreholeOptions = ref([]);
    const stageOptions = ref([]);
    const countryOptions = ref([]);
    let stratigraphy = reactive({
      list: null
    });
    let showStratigraphy = reactive({
      list: null
    });
    const handleChangeSectionOrBorhole = value => {
      console.log(value);
      showStratigraphy.list = stratigraphy.list.filter(item => {
        const stageCompare = stageValue.value ? item.stage == stageValue.value : true;
        const countryCompare = countryValue.value ? item.country == countryValue.value : true;
        return item.section_Or_Borehole == value && stageCompare && countryCompare;
      });
    };
    const handleChangeStratigraphic = value => {
      sectionOrBoreholeValue.value = '';
      stageValue.value = '';
      countryValue.value = '';
      getDataByStratigraphy(value).then(res => {
        console.log(res);
        stratigraphy.list = null;
        showStratigraphy.list = null;
        stratigraphy.list = res;
        showStratigraphy.list = res;
        sectionOrBoreholeOptions.value = Array.from(new Set(stratigraphy.list.map(item => {
          return item.section_Or_Borehole;
        })));
        stageOptions.value = Array.from(new Set(stratigraphy.list.map(item => {
          return item.stage;
        })));
        countryOptions.value = Array.from(new Set(stratigraphy.list.map(item => {
          return item.country;
        })));
        tableArr.list = null;
        console.log(lithology, Chronostratigraphy, Chemostratigpraphy, Cyclostratigraphy);
        switch (value) {
          case 'Chemostratigraphy':
            tableArr.list = Chemostratigpraphy;
            console.log(tableArr.list, Chemostratigpraphy);
            break;
          case 'Chronostratigraphy':
            tableArr.list = Chronostratigraphy;
            break;
          case 'Cyclostratigraphy':
            tableArr.list = Cyclostratigraphy;
            break;
          case 'Lithology':
            tableArr.list = lithology;
            break;
          default:
            break;
        }
        console.log(stageOptions, countryOptions);
      });
    };
    const handleChangeStage = value => {
      showStratigraphy.list = stratigraphy.list.filter(item => {
        const sectionCompare = sectionOrBoreholeValue.value ? item.section_Or_Borehole == sectionOrBoreholeValue.value : true;
        const countryCompare = countryValue.value ? item.country == countryValue.value : true;
        return item.stage == value && sectionCompare && countryCompare;
      });
    };
    const handleChangeCountry = value => {
      showStratigraphy.list = stratigraphy.list.filter(item => {
        const sectionCompare = sectionOrBoreholeValue.value ? item.section_Or_Borehole == sectionOrBoreholeValue.value : true;
        const stageCompare = stageValue.value ? item.stage == stageValue.value : true;
        return item.country == value && sectionCompare && stageCompare;
      });
    };
    const handleClearSection = () => {
      showStratigraphy.list = stratigraphy.list.filter(item => {
        const stageCompare = stageValue.value ? item.stage == stageValue.value : true;
        const countryCompare = countryValue.value ? item.country == countryValue.value : true;
        return stageCompare && countryCompare;
      });
    };
    const handleClearStage = () => {
      showStratigraphy.list = stratigraphy.list.filter(item => {
        const sectionCompare = sectionOrBoreholeValue.value ? item.section_Or_Borehole == sectionOrBoreholeValue.value : true;
        const countryCompare = countryValue.value ? item.country == countryValue.value : true;
        return sectionCompare && countryCompare;
      });
    };
    const handleClearCountry = () => {
      showStratigraphy.list = stratigraphy.list.filter(item => {
        const sectionCompare = sectionOrBoreholeValue.value ? item.section_Or_Borehole == sectionOrBoreholeValue.value : true;
        const stageCompare = stageValue.value ? item.stage == stageValue.value : true;
        return sectionCompare && stageCompare;
      });
    };
    // const downloadExcel = () => {
    //   exportExcel(showStratigraphy.list, tableArr.list)
    // }
    const downloadExcel = async () => {
      try {
        exportExcel(showStratigraphy.list, tableArr.list);
        // 调用下载统计接口
        await axios.get('https://pabapi.machao.group/OAE/downloads');
        ElMessage.success('下载成功');
      } catch (error) {
        ElMessage.error('下载失败: ' + error.message);
      }
    };
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_menu, {
        "default-active": activeIndex.value,
        class: "el-menu-demo",
        mode: "horizontal",
        onSelect: _ctx.handleSelect
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu_item, {
          index: "/"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("span", {
            class: "logo"
          }, "PaleoAnoxic Database(PAD) ", -1)])),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createElementVNode("span", {
            class: "menuItem"
          }, "Search", -1)])),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "help"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createElementVNode("span", {
            class: "menuItem"
          }, "Help", -1)])),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "about"
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [_createElementVNode("span", {
            class: "menuItem"
          }, "About", -1)])),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "contact"
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createElementVNode("span", {
            class: "menuItem"
          }, "Contact", -1)])),
          _: 1
        })]),
        _: 1
      }, 8, ["default-active", "onSelect"]), _createElementVNode("div", _hoisted_2, [_cache[17] || (_cache[17] = _createElementVNode("p", {
        class: "introduction"
      }, [_createTextVNode(" Welcome to the "), _createElementVNode("span", {
        style: {
          "font-weight": "bold"
        }
      }, "Oceanic Anoxic Events Database,"), _createTextVNode(" your comprehensive platform for exploring the time, location, and sedimentary contexts of Earth's most intriguing ocean anoxia events! ")], -1)), _createElementVNode("div", _hoisted_3, [_cache[13] || (_cache[13] = _createElementVNode("span", {
        style: {
          "font-size": "xx-large",
          "line-height": "120px"
        }
      }, "Search:", -1)), _createElementVNode("div", _hoisted_4, [_cache[9] || (_cache[9] = _createElementVNode("div", {
        style: {
          "margin-bottom": "15px"
        }
      }, "Stratigraphic Disciplines", -1)), _createVNode(_component_el_select, {
        modelValue: stratigrapthyValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => stratigrapthyValue.value = $event),
        placeholder: "Select",
        size: "large",
        style: {
          "width": "100%"
        },
        onChange: handleChangeStratigraphic
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(stratigraphyOptions, item => {
          return _createVNode(_component_el_option, {
            key: item,
            label: item,
            value: item
          }, null, 8, ["label", "value"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_cache[10] || (_cache[10] = _createElementVNode("div", {
        style: {
          "margin-bottom": "15px"
        }
      }, "Section Or Borehole", -1)), _createVNode(_component_el_select, {
        modelValue: sectionOrBoreholeValue.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => sectionOrBoreholeValue.value = $event),
        placeholder: "Select",
        size: "large",
        style: {
          "width": "100%"
        },
        clearable: "",
        onClear: handleClearSection,
        onChange: handleChangeSectionOrBorhole
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sectionOrBoreholeOptions.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item,
            label: item,
            value: item
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_cache[11] || (_cache[11] = _createElementVNode("div", {
        style: {
          "margin-bottom": "15px"
        }
      }, "Stage", -1)), _createVNode(_component_el_select, {
        modelValue: stageValue.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => stageValue.value = $event),
        placeholder: "Select",
        size: "large",
        style: {
          "width": "100%"
        },
        clearable: "",
        onClear: handleClearStage,
        onChange: handleChangeStage
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stageOptions.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item,
            label: item,
            value: item
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_7, [_cache[12] || (_cache[12] = _createElementVNode("div", {
        style: {
          "margin-bottom": "15px"
        }
      }, "Country", -1)), _createVNode(_component_el_select, {
        modelValue: countryValue.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => countryValue.value = $event),
        placeholder: "Select",
        size: "large",
        clearable: "",
        onClear: handleClearCountry,
        style: {
          "width": "100%"
        },
        onChange: handleChangeCountry
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countryOptions.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item,
            label: item,
            value: item
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_8, [_cache[15] || (_cache[15] = _createElementVNode("span", {
        class: "title"
      }, "Metadata", -1)), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(metadataArr, item => {
        return _createElementVNode("div", {
          key: item,
          class: "metaItem"
        }, [_createElementVNode("span", _hoisted_9, _toDisplayString(item.title), 1), _cache[14] || (_cache[14] = _createTextVNode("： ")), _unref(showStratigraphy).list && _unref(showStratigraphy).list.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(showStratigraphy).list && _unref(showStratigraphy).list[0][item.name]), 1)) : _createCommentVNode("", true)]);
      }), 64))]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
        onClick: downloadExcel
      }, {
        default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("download")])),
        _: 1
      }), _createVNode(_component_el_table, {
        data: _unref(showStratigraphy).list,
        stripe: "",
        style: {
          "width": "100%",
          "margin-top": "30px"
        },
        height: 400
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableArr).list, item => {
          return _openBlock(), _createBlock(_component_el_table_column, {
            prop: item.prop,
            label: item.label,
            key: item.label,
            width: item.prop == 'reference' ? 300 : 180,
            fixed: item.prop == 'id',
            align: "center",
            "vertical-align": "middle"
          }, null, 8, ["prop", "label", "width", "fixed"]);
        }), 128))]),
        _: 1
      }, 8, ["data"])])]), _createVNode(FooterView)]);
    };
  }
};